module.exports = __webpack_public_path__ + "static/media/16_avatar.708f2f6b.png";